/**
 * Created by hp on 2017/6/9.
 */
import React, {Component} from "react";
import {connect} from "react-redux";
import {Mask, Button} from "react-weui";
import {renderMoney, getJsonFromUrl} from '../../utils';
import Config from '../../config';
import axios from 'axios';

import LecturePaySinglePanel from './LecturePaySinglePanel';
import LecturePaySingleChannelPanel from './LecturePaySingleChannelPanel';
import LecturePayMonthPanel from './LecturePayMonthPanel';
import LecturePayLecturesPanel from './LecturePayLecturesPanel';
import LectureDiscountPanel from './LectureDiscountPanel';

import "../../styles/lecture/LecturePayPanel.css";
import noDicountImg from '../../images/nodiscount.png';
import { setEvent } from "../../services";

class LecturePayPanel extends Component {
    constructor() {
        super();
        this.onRequestClose = this.onRequestClose.bind(this);
        this.onPayHandle = this.onPayHandle.bind(this);
        this.onCheckDiscount = this.onCheckDiscount.bind(this);
    }

    componentWillMount() {
        const {role, lectureAccess, channelAccess} = this.props;
        let params = getJsonFromUrl();

        if (params.discount_code && !(role.is_manager || role.is_lecturer) && !lectureAccess.granted) {
            if (channelAccess && !channelAccess.granted) {
                this.onCheckDiscount();
            } else if (!channelAccess) {
                this.onCheckDiscount();
            }
        }
    }

    onCheckDiscount() {
        return 
        
        let {lectureId} = this.props;
        let params = getJsonFromUrl();
        axios.post(`/api/lecture/${lectureId}/discount/${params.discount_code}/check`).then(res => {
            if (res.data.code === 0) {
                this.props.dispatch({
                    type: 'LECTURE_SET_DISCOUNT',
                    payload: res.data.data.discount
                });
                this.props.dispatch({
                    type: 'LECTURE_SHOW_DISCOUNT_PAY_PANEL'
                });
                this.props.dispatch({
                    type: 'MTA_CLICK',
                    payload: 'lecture_discountfromurl'
                })
            } else {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: res.data.msg,
                        img: noDicountImg,
                        href: `/lecture/${lectureId}`,
                        btn: '回到课程'
                    }
                });
            }
        });
    }

    onRequestClose() {
        const {showDiscountPayPanel} = this.props;

        if (showDiscountPayPanel) {
            this.props.dispatch({
                type: 'LECTURE_HIDE_DISCOUNT_PAY_PANEL'
            });
        }

        this.props.dispatch({
            type: 'LECTURE_HIDE_PAY_PANEL'
        });
    }

    onPayHandle() {
        const {lectureId, isSelectSingleChannel, isSelectMonthChannel, channel, priceRecordId, discount, showDiscountPayPanel, meta} = this.props;

        this.onRequestClose();
        // 默认课程付费
        let type = 'PAY_LECTURE';
        let params = {
            product: 'pay_lecture',
            lecture_id: lectureId,
            platform: meta.platform,
            user_sign: meta.user_sign,
        };
        //单课点击支付统计
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_singleclass'
        });

        setEvent({name: 'wk_lecture-pay-single'})

        // 专栏固定付费
        if (isSelectSingleChannel) {
            type = 'PAY_CHANNEL';
            params = {
                product: 'pay_channel',
                channel_id: channel.id,
                platform: meta.platform,
                user_sign: meta.user_sign,
            };
            //专栏点击支付统计
            this.props.dispatch({
                type: 'MTA_CLICK',
                payload: 'lecture_columnPayBegin'
            });
            setEvent({name: 'wk_lecture-pay-channel'})
        }

        // 专栏按时收费
        if (isSelectMonthChannel) {
            type = 'PAY_CHANNEL';
            params = {
                product: 'pay_channel',
                channel_id: channel.id,
                price_record_id: priceRecordId,
            };
            //专栏点击支付统计
            this.props.dispatch({
                type: 'MTA_CLICK',
                payload: 'lecture_channelpaybegin'
            });
        }

        // 优惠券付费
        if (showDiscountPayPanel && discount && discount.price) {
            type = 'PAY_LECTURE';
            params = {
                product: 'pay_lecture',
                lecture_id: lectureId,
                discount_code: discount.code,
                discount_id: discount.id,
                platform: meta.platform,
                user_sign: meta.user_sign,
            };
            //优惠点击支付统计
            this.props.dispatch({
                type: 'MTA_CLICK',
                payload: 'lecture_discountpay'
            });
            setEvent({name: 'wk_lecture-pay-discount-panel'})
        }

        //发起支付
        this.props.dispatch({
            type: type,
            payload: {
                params: params,
                success: () => {
                    this.props.dispatch({
                        type: 'LECTURE_SET_GRANTED',
                        payload: {
                            lecture_access: {
                                granted: true
                            }
                        }
                    });

                    if (discount && discount.price) {
                        this.props.dispatch({
                            type: 'MTA_CLICK',
                            payload: 'lecture_discountpay'
                        });
                        this.props.dispatch({
                            type: 'LECTURE_HIDE_DISCOUNT_PAY_PANEL'
                        });
                        window.location = Config.MAIN_URL + `/lecture/${lectureId}/paysuccess${location.search}`;
                    } else if (isSelectMonthChannel || isSelectSingleChannel) {
                        this.props.dispatch({
                            type: 'MTA_CLICK',
                            payload: 'lecture_channelpayfinish'
                        });
                        window.location = Config.MAIN_URL + `/channel/${channel.id}/paysuccess${location.search}`;
                    } else {
                        this.props.dispatch({
                            type: 'MTA_CLICK',
                            payload: 'lecture_singleclassfinishpay'
                        });
                        window.location = Config.MAIN_URL + `/lecture/${lectureId}/paysuccess${location.search}`;
                    }
                },
                fail: (data) => {
                    if (data.code === 2) {
                        isSelectSingleChannel ? this.context.page.showToast('已购买专栏') : this.context.page.showToast('已购买课程');
                        this.props.dispatch({
                            type: 'LECTURE_SET_GRANTED',
                            payload: {
                                lecture_access: {
                                    granted: true
                                }
                            }
                        })
                    }
                }
            }
        })
    }

    render() {
        const {channel, showDiscountPayPanel, showPayPanel} = this.props;
        let isChannelCostFix = channel && channel.is_cost_fix;
        const limitPrice = channel && channel.promoprice
        if (!showPayPanel) {
            return null;
        }

        return (
            <div className="lecture-pay-panel">
                <Mask onClick={this.onRequestClose}/>
                <div className={`panel-content weui-actionsheet weui-actionsheet_toggle`} >
                    {showDiscountPayPanel &&
                    <LectureDiscountPanel />
                    }

                    {!showDiscountPayPanel &&
                    <div className="weui-actionsheet___menu">
                        {channel.id !== 58123 && channel.id !== 62884 && this.props.lecture.lecture_type !== 'pay_channel' &&
                        <LecturePaySinglePanel />
                        }

                        <div className="">
                            <LecturePaySingleChannelPanel />

                            <div className="lecture-pay-item-scroll">
                                {isChannelCostFix &&
                                <div className="weui-actionsheet__cell weui-padding bg-cell-item wk-border-line-bottom">
                                    <div className="weui-flex text-left channel-text">
                                        <span className="weui-flex__item text-ellipsis text-grey flex_3">
                                            {this.props.lecture.lecture_type === 'pay_channel' ? '此课程不可单买，请购买专栏' : '以优惠价购买专栏可收听以下课程'}
                                        </span>
                                        {
                                            limitPrice ? (
                                                <span className="weui-flex__item text-center channel-down-money">
                                                    限时特价中
                                                </span>
                                            ) : (
                                                (channel.all_lecture_money - channel.money > 0) &&
                                                <span className="weui-flex__item text-center channel-down-money">
                                                    立省 ¥{renderMoney(channel.all_lecture_money - channel.money)}
                                                </span>
                                            )
                                        }
                                    </div>
                                </div>
                                }
                                {isChannelCostFix ?
                                    <LecturePayLecturesPanel />
                                    :
                                    <LecturePayMonthPanel />
                                }
                            </div>
                        </div>
                    </div>
                    }

                    <div className="channel-student-bottom">
                        <div className="channel-pay-channel">
                            <Button onClick={this.onPayHandle}>下一步</Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

LecturePayPanel.contextTypes = {
    page: React.PropTypes.object,
};

export default connect((state) => ({
    channel: state.lecture.channel,
    isSelectSingleLecture: state.lecture.isSelectSingleLecture,
    isSelectSingleChannel: state.lecture.isSelectSingleChannel,
    isSelectMonthChannel: state.lecture.isSelectMonthChannel,
    lectureId: state.lecture.lecture.id,
    showDiscountPayPanel: state.lecture.showDiscountPayPanel,
    priceRecordId: state.lecture.priceRecordId,
    discount: state.lecture.discount,
    role: state.lecture.role,
    showPayPanel: state.lecture.showPayPanel,
    lectureAccess: state.lecture.lecture_access,
    channelAccess: state.lecture.channel_access,
    lecture: state.lecture.lecture,
    meta: state.lecture.meta,
}))(LecturePayPanel);


// WEBPACK FOOTER //
// ./src/components/lecture/LecturePayPanel.js